import React, { useState } from 'react';
import { OPEN_STATUSES, TEMPERATURES, followupState, stockLabel } from './config';
import { L, Chips } from './ui';
import LeadCard from './LeadCard';


// Leads asignados al usuario, agrupados por estado y ordenados por urgencia del seguimiento.
export default function MiCartera({ leads, currentUserId, vehicles, columns, onOpen }) {
  const [view, setView] = useState('abiertos');
  const [temp, setTemp] = useState('todas');
  const [q, setQ] = useState('');

  const mine = leads.filter(l => l.assigned_to === currentUserId);
  const openMine = mine.filter(l => OPEN_STATUSES.includes(l.status));
  const late = openMine.filter(l => followupState(l).key === 'late').length;
  const today = openMine.filter(l => followupState(l).key === 'today').length;
  const noContact = openMine.filter(l => !l.first_contact_at).length;

  const needle = q.trim().toLowerCase();
  const filtered = mine
    .filter(l => view === 'todos' || (view === 'abiertos' ? OPEN_STATUSES.includes(l.status) : !OPEN_STATUSES.includes(l.status)))
    .filter(l => temp === 'todas' || l.temperature === temp)
    .filter(l => !needle || [l.customer_name, l.phone, l.vehicle_text, l.vehicle_plate].some(v => (v || '').toLowerCase().includes(needle)));


  if (mine.length === 0) {
    return (
      <div style={{ textAlign: 'center', padding: '40px 12px' }}>
        <div style={{ fontSize: '2rem' }}>🗂️</div>
        <p style={{ color: 'var(--t-cbd5e1)', margin: '8px 0 4px' }}>Todavía no tienes leads.</p>
        <p style={L.muted}>Coge uno de la Bandeja o espera a que te asignen alguno.</p>
      </div>
    );
  }

  return (
    <div style={{ display: 'grid', gap: '12px' }}>
      <div style={{ display: 'flex', flexWrap: 'wrap', gap: '8px' }}>
        <Counter n={late} label="vencidos" color="var(--t-f87171)" />
        <Counter n={today} label="para hoy" color="var(--t-fbbf24)" />
        <Counter n={openMine.length} label="abiertos" color="var(--t-93c5fd)" />
      </div>
      <input
        aria-label="Buscar en mi cartera"
        placeholder="Buscar por nombre, teléfono, coche o matrícula…"
        value={q}
        onChange={e => setQ(e.target.value)}
        style={{ ...L.input, marginBottom: 0 }}
      />
      <div style={{ display: 'flex', flexWrap: 'wrap', gap: '8px 16px', alignItems: 'center' }}>
        <Chips small value={view} onChange={setView} options={[
          { key: 'abiertos', label: 'Abiertos' }, { key: 'cerrados', label: 'Cerrados' }, { key: 'todos', label: 'Todos' }
        ]} />
        <Chips small value={temp} onChange={setTemp} options={[{ key: 'todas', label: 'Todas' }, ...TEMPERATURES]} />
      </div>

      {filtered.length === 0 && <p style={L.muted}>Ningún lead coincide con el filtro.</p>}
      {/* Los más recientes primero (por hora de entrada). */}
      <div style={{ display: 'grid', gap: '8px' }}>
        {[...filtered].sort((a, b) => new Date(b.received_at) - new Date(a.received_at)).map(lead => (
          <LeadCard key={lead.id} lead={lead} mode="cartera" stock={stockLabel(lead, vehicles, columns)} onOpen={() => onOpen(lead.id)} />
        ))}
      </div>
    </div>
  );
}

function Counter({ n, label, color }) {
  return (
    <div style={{ backgroundColor: 'var(--b-0f172a)', border: '1px solid var(--l-334155)', borderRadius: '8px', padding: '6px 10px', display: 'flex', alignItems: 'baseline', gap: '6px' }}>
      <strong style={{ color: n > 0 ? color : 'var(--t-6b7280)', fontSize: '1.05rem' }}>{n}</strong>
      <span style={{ color: 'var(--t-9ca3af)', fontSize: '0.78rem' }}>{label}</span>
    </div>
  );
}
